import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import DropDownIcon from '../../assets/dropdownicon.svg';

interface Option {
  label: string;
  value: string;
}

interface DropdownProps {
  options: Option[];
  value?: string;
  placeholder?: string;
  onChange: (value: string) => void;
  analyticsName?: string;
}

const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
`;

const DropdownButton = styled.button`
  width: 100%;
  height: 40px;
  padding: 0 12px;
  font-size: 14px;
  text-align: left;
  border: 1px solid #ccc;
  background-color: white;
  border-radius: 6px;
  color: #464646;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

// 아이콘 래퍼 (필요 시 크기 조정)
const Icon = styled.img`
  width: 14px;
  height: 14px;
  margin-left: 8px;
  opacity: 0.7;
`;

const DropdownList = styled.ul`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  max-height: 240px;
  overflow: auto;
  margin: 0;
  padding: 8px 0;
  list-style: none;
  background: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.08);
  z-index: 10;
`;

const DropdownItem = styled.li<{ active?: boolean }>`
  padding: 8px 12px;
  font-size: 14px;
  color: ${({ active }) => (active ? "#14B446" : "#464646")};
  background: ${({ active }) => (active ? "rgba(20,180,70,0.06)" : "transparent")};
  cursor: pointer;

  &:hover {
    background: #f6f6f6;
  }
`;

export const BTDropdown: React.FC<DropdownProps> = ({
  options,
  value,
  placeholder = "Select an option",
  onChange,
  analyticsName,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel = options.find(o => o.value === value)?.label;

  const handleSelect = (v: string) => {
    onChange(v);
    setIsOpen(false);
  };

  return (
    <DropdownContainer ref={ref}>
      <DropdownButton onClick={() => setIsOpen(prev => !prev)}>
        {selectedLabel ?? placeholder}
        <Icon src={DropDownIcon} alt="dropdown icon" />
      </DropdownButton>

      {isOpen && (
        <DropdownList>
          {options.map(opt => (
            <DropdownItem
              key={opt.value}
              active={opt.value === value}
              onClick={() => handleSelect(opt.value)}
              data-analytics-name={analyticsName ? `${analyticsName}_${opt.label}` : undefined}
            >
              {opt.label}
            </DropdownItem>
          ))}
        </DropdownList>
      )}
    </DropdownContainer>
  );
};
